<template>
    <div class="footer">
        <div class="footer-inner" v-if="showContactInfo">
            <div class="info-item">
                <i class="iconfont icon-dianhua"></i>
                <p>公司电话：</p>
                <p>{{ contactInfoData.phone }}</p>
            </div>
            <div class="info-item">
                <i class="iconfont icon-youxiang"></i>
                <p>邮箱地址：</p>
                <p>{{ contactInfoData.email }}</p>
            </div>
            <div class="info-item ">
                <i class="iconfont icon-dizhi"></i>
                <p>公司地址：</p>
                <p class="address">{{ contactInfoData.address }}</p>
            </div>
        </div>
        <div class="beian">
            <div class="beian-inner">
                <p>Copyright © </p>
                <a href="https://www.youxuanit.com/" target="_blank">优选创新（北京）科技有限公司
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                    备案号：京ICP备15028437号
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo">
                    <img :src="require('../../../static/img/beian.png')" alt="">
                    京公网安备 11010802032912号
                </a>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Footer",
    props: {
        showContactInfo: {
            type: Boolean,
            default: false
        },
        contactInfoData: {
            type: Object,
            default: () => {
                return {
                    phone: '010-82894771',
                    email: 'service@ipieuvre.com',
                    address: '北京市海淀区上地信息路2号中关村国际孵化园D座309'
                }
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.footer {
    --size14: 14px;
    --size12: 12px;
    background: #3E3D3C;

    .footer-inner {
        width: 960px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 28px 0 24px 0;
        gap: 106px;

        .info-item {
            display: flex;

            p,
            i {
                font-size: var(--size14);
                color: #B8B8B8;
                white-space: nowrap;
            }

            i {
                margin-right: 8px;
                line-height: calc(var(--size14) + 6px);
            }

            .address {
                white-space: wrap;
            }
        }
    }

    .beian {
        border-top: 1px solid #656565;

        .beian-inner {
            padding: 13px 0;
            font-weight: 400;
            font-size: var(--size12);
            color: #A4A4A4;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            white-space: nowrap;

            a {
                color: #A4A4A4;

                &:hover {
                    color: #d1d1d1;
                }
            }

            img {
                width: 14px;
                height: 14px;
                vertical-align: middle;
            }
        }
    }
}

@media screen and (max-width:1200px) {
    .footer {
        .footer-inner {
            width: 900px;
        }
    }
}

@media screen and (max-width:992px) {
    .footer {
        --size14: 14px;

        .footer-inner {
            width: 720px;
            gap: 20px;
        }
    }
}

@media screen and (max-width:768px) {
    .footer {
        --size14: 13px;

        .footer-inner {
            flex-wrap: wrap;
            justify-content: flex-start;
            width: 100%;
            padding: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newFooter/footer.vue